export const getHtmlContentStyles = (className: string, options?: {
  h1LineHeight?: string;
  pDisplay?: string;
  headingsDisplay?: string;
}) => {
  const pDisplayStyle = options?.pDisplay ? `display: ${options.pDisplay};` : '';
  const h1LineHeightStyle = options?.h1LineHeight ? `line-height: ${options.h1LineHeight};` : '';
  const headingsDisplayStyle = options?.headingsDisplay ? `display: ${options.headingsDisplay};` : '';
  const ulOlDisplayStyle = options?.headingsDisplay ? 'display: block;' : '';

  return `
    .${className} p {
      margin: 0;
      ${pDisplayStyle}
    }
    .${className} p:not(:last-child) {
      margin-bottom: 0.5rem;
    }
    .${className} ul,
    .${className} ol {
      margin: 0.5rem 0;
      padding-left: 1.5rem;
      ${ulOlDisplayStyle}
    }
    .${className} ul {
      list-style-type: disc;
    }
    .${className} ol {
      list-style-type: decimal;
    }
    .${className} li {
      margin: 0.25rem 0;
    }
    .${className} h1 {
      font-size: 2em;
      font-weight: bold;
      margin: 0.67em 0;
      ${h1LineHeightStyle}
      ${headingsDisplayStyle}
    }
    .${className} h2 {
      font-size: 1.5em;
      font-weight: bold;
      margin: 0.75em 0;
      ${headingsDisplayStyle}
    }
    .${className} h3 {
      font-size: 1.17em;
      font-weight: bold;
      margin: 0.83em 0;
      ${headingsDisplayStyle}
    }
    .${className} a {
      text-decoration: underline;
    }
    .${className} a span {
      text-decoration: underline;
    }
  `;
};
